import { createApp } from 'vue'
import App from './App.vue'
import router from './router/route'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faChevronLeft,
  faChevronRight,
  faAngleDoubleRight,
  faTimes,
  faInfo,
  faMapMarkerAlt,
  faSortDown,
  faPhoneAlt,
  faPhone,
  faCreditCard,
  faPlus,
  faBars,
  faUser,
  faMinus,
  faUsers,
  faCross,
  faAngleLeft,
  faAngleRight,
  faCheck,
  faStar,
  faFilter,
  faHandHoldingHeart,
  faGlobeAmericas,
  faDollarSign,
  faSortUp,
  faLongArrowAltDown,
  faLongArrowAltUp,
  faFilePdf,
  faUserLock,
  faCashRegister,
  faCircleNotch,
  faCheckCircle,
  faExclamationCircle,
  faClipboard,
  faPencilAlt,
  faQrcode,
  faClock,
  faChevronDown,
  faChevronUp,
} from '@fortawesome/free-solid-svg-icons'
import i18n from './i18n'
import {faFacebookF, faInstagram, faLinkedinIn, faWhatsapp, faWhatsappSquare} from "@fortawesome/free-brands-svg-icons";
import PerfectScrollbar from 'vue3-perfect-scrollbar'
import 'vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css'
import Maska from "maska";
import TabIcon from "@/components/TabIcon.vue";
import LegacyIcon from "@/components/LegacyIcon.vue";
import ValidateDirective from "@/components/directives/ValidateDirective.js";
import InlineSvg from "@/components/InlineSvg.vue";
import Loading from 'vue-loading-overlay';
import mitt from 'mitt'
import VueClipboard from "vue-clipboard2";
import moment from "moment/moment";
import { createGtm } from '@gtm-support/vue-gtm';
import VueTippy from 'vue-tippy'
import TabView from 'primevue/tabview'
import TabPanel from "primevue/tabpanel";
import PrimeVue from "primevue/config";
import {VueReCaptcha} from "vue-recaptcha-v3";
import {GOOGLE_RECAPTCHA_KEY_ID} from "@/constants";
import VueExcelEditor from 'vue3-excel-editor'

library.add(faChevronRight)
library.add(faChevronLeft)
library.add(faAngleDoubleRight)
library.add(faTimes)
library.add(faInfo)
library.add(faMapMarkerAlt)
library.add(faSortDown);
library.add(faSortUp);
library.add(faWhatsapp)
library.add(faPhoneAlt)
library.add(faPhone)
library.add(faCreditCard)
library.add(faPlus)
library.add(faMinus)
library.add(faBars)
library.add(faFacebookF)
library.add(faInstagram);
library.add(faLinkedinIn);
library.add(faUser);
library.add(faCross);
library.add(faUsers);
library.add(faCheck);
library.add(faStar);
library.add(faFilter);
library.add(faGlobeAmericas);
library.add(faHandHoldingHeart);
library.add(faDollarSign);
library.add(faLongArrowAltDown);
library.add(faLongArrowAltUp);
library.add(faFilePdf);
library.add(faUserLock);
library.add(faWhatsappSquare);
library.add(faPhoneAlt);
library.add(faCashRegister);
library.add(faCreditCard);
library.add(faCircleNotch);
library.add(faCheckCircle);
library.add(faExclamationCircle);
library.add(faClipboard);
library.add(faPencilAlt);
library.add(faQrcode);
library.add(faClock);
library.add(faChevronDown);
library.add(faChevronUp);
library.add(faAngleLeft);
library.add(faAngleRight);
const emitter = mitt();
const app = createApp(App).use(i18n)
  .component('fa-icon', FontAwesomeIcon)
  .use(store)
  .use(VueAxios, axios)
  .use(router)
  .use(createGtm({
    id: 'GTM-WRN8BJF',
    vueRouter: router,
    enabled: true,
    debug: true
  }))
  .use(Maska)
  .use(PerfectScrollbar)
  .use(VueClipboard)
  .use(VueTippy)
  .use(PrimeVue)
  .use(VueReCaptcha, {siteKey: GOOGLE_RECAPTCHA_KEY_ID, loaderOptions: {useEnterprise: true, renderParameters: {badge: 'bottomleft'}}})
  .component('TabIcon', TabIcon)
  .component('inline-svg', InlineSvg)
  .component('Loading', Loading)
  .component('legacy-icon', LegacyIcon)
  .component('TabView', TabView)
  .component('TabPanel', TabPanel)
  .directive('validate', ValidateDirective);
app.config.globalProperties.emitter = emitter;
app.config.globalProperties.$filters = {
  currency(value: number, prefix = "R$"): string {
    return prefix+this.thousandSeparator(value.toFixed(2).replace('.', ','));
  },
  thousandSeparator(value: number|string): string {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
  },
  dateFormat(value: Date, format?: string) {
    return moment(value).format(format || "DD/MM/YYYY");
  }
}
app.mount('#app')
